import React from 'react';
import InputTitleView from './InputTitleView';
import IntlMessages from 'Util/IntlMessages';

const ButtonInputView = ({ title = '', required = false, subTitle = '', items = null, name, value, onChange }) => {
  if (!title || !items) return <></>;

  const onClickItem = itemValue => {
    let newValue = [...value];
    if (value.includes(itemValue)) {
      newValue = newValue.filter(x => x !== itemValue);
    } else {
      newValue = [...newValue, itemValue];
    }
    onChange({ name, value: newValue });
  };

  const onClickAll = () => {
    if (Object.keys(items).length === value.length) {
      onChange({ name, value: [] });
    } else {
      onChange({ name, value: Object.keys(items) });
    }
  };

  return (
    <div className="recruitment-button-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className="recruitment-button-input-view-button-wrapper">
        {name === 'constructionAreas' && (
          <div key="all" className="recruitment-button-input-view-button" onClick={onClickAll}>
            <IntlMessages id="recruitment.constructionAreas.all" />
          </div>
        )}
        {Object.entries(items).map(x => (
          <div
            key={x[0]}
            className={`recruitment-button-input-view-button ${value?.includes(x[0]) && 'selected'}`}
            onClick={() => {
              onClickItem(x[0]);
            }}
          >
            {x[1]}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ButtonInputView;
